export default __webpack_public_path__ + "static/media/logo.7eb05e7c.svg";